import {Component} from "@angular/core";
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {i18nService} from "src/app/service-utils/i18n.service";
import {RegisterRequest} from "../../../model/register/register-request.model";
import {RegisterService} from "./register.service";
import {Router} from "@angular/router";
import {emailValidator, phoneValidator, requiredFieldValidator, zipValidator} from "../../validation/validators";
import { ValidatorService } from "src/app/service-utils/validator-service";

@Component({
  selector: 'app-register-dialog',
  templateUrl: './register-dialog.component.html',
  styleUrls: ['./register-dialog.component.scss']
})
export class RegisterDialogComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<RegisterDialogComponent>,
    public i18nService: i18nService,
    private formBuilder: FormBuilder,
    private registration: RegisterService,
    private router: Router,
    private validatorService: ValidatorService
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      customerNumber:  new FormControl('', requiredFieldValidator()),
      customerName:  new FormControl('', requiredFieldValidator()),
      email:  new FormControl('', [requiredFieldValidator(), emailValidator]),
      city:  new FormControl(''),
      zip:  new FormControl('', [zipValidator]),
      phone:  new FormControl('', [phoneValidator]),
    });
  }

  register() {
    event.stopPropagation();

    this.form.get('customerNumber').markAsTouched();
    this.form.get('customerName').markAsTouched();
    this.form.get('email').markAsTouched();

    if (this.form.valid) {
      let data: RegisterRequest = {...this.form.value};
      this.registration.register(data).subscribe(response => {
        if (response.success) {
          console.log("registration.success");
          this.router.navigate(['/home']);
        } else {
          console.log(response.httpError);
        }
      });
      this.dialogRef.close();
    }
  }
}
